function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.2676 16C17.6134 16.5978 18.2597 17 19 17C20.1046 17 21 16.1046 21 15C21 14.9519 20.9983 14.9041 20.995 14.8569",
  stroke: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 3,
  width: 7,
  height: 6,
  stroke: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 4H16C15.4477 4 15 4.44772 15 5V5C15 5.55228 15.4477 6 16 6H17.5",
  stroke: "black"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M6 15C6 16.1046 5.10457 17 4 17C2.89543 17 2 16.1046 2 15",
  stroke: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M1 15L1 14C1 12.3431 2.34315 11 4 11C5.65685 11 7 12.3431 7 14L7 15",
  stroke: "black",
  strokeLinecap: "square"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M4.5 3V5",
  stroke: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M16 15V15.5H16.0734L16.1437 15.4789L16 15ZM21 13.5L21.1437 13.9789L21.5 13.872V13.5H21ZM15.5528 11.7764L15.3292 12.2236L16.2236 12.6708L16.4472 12.2236L15.5528 11.7764ZM1 15.5H16V14.5H1V15.5ZM16.1437 15.4789L21.1437 13.9789L20.8563 13.0211L15.8563 14.5211L16.1437 15.4789ZM18 11.5C19.7239 11.5 20.5 12.7761 20.5 13.5H21.5C21.5 12.2239 20.2761 10.5 18 10.5V11.5ZM16.4472 12.2236C16.5944 11.9293 17.145 11.5 18 11.5V10.5C16.855 10.5 15.9056 11.0707 15.5528 11.7764L16.4472 12.2236Z",
  fill: "black"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M3.5 11L2.5 9",
  stroke: "black"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M8 9H8.48444C9.55468 9 10.3827 9.93802 10.25 11L10.2203 11.2378C10.1033 12.1735 10.8329 13 11.7759 13V13C12.4953 13 13.1224 12.5104 13.2969 11.8125L14.5 7",
  stroke: "black"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M15 4L14 3",
  stroke: "black"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M17 6L18 11",
  stroke: "black"
});

var SvgDelivery = function SvgDelivery(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDelivery, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delivery.0a369218.svg";
export { ForwardRef as ReactComponent };